import { motion } from "framer-motion";
import { FileText, Image as ImageIcon, Mail, Rss, Share2, Youtube } from "lucide-react";
import { ECOSYSTEM_CHANNELS, ECOSYSTEM_SITES } from "@/data/site";

const ICON_MAP = {
  articoli: FileText,
  banner: ImageIcon,
  dem: Mail,
  newsletter: Rss,
  social: Share2,
  youtube: Youtube,
};

export default function Ecosystem() {
  return (
    <section id="distribuzione" data-testid="ecosystem-section" className="relative py-20 md:py-32 bg-white border-t border-black/[0.08]">
      <div className="max-w-[1280px] mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-8 mb-14 md:mb-20">
          <div className="lg:col-span-4">
            <div className="label-eyebrow mb-4 flex items-center gap-3">
              <span>III.</span>
              <span className="w-5 h-px bg-black/25" />
              <span>La distribuzione</span>
            </div>
          </div>
          <div className="lg:col-span-8">
            <h2 className="font-display tighter text-[#121212] text-4xl md:text-5xl lg:text-[3.8vw] leading-[1.02] font-normal">
              La visibilità continua,
              <br />
              <span className="italic text-[#FF6B1A]">su più canali</span>.
            </h2>
            <p className="mt-6 text-[#121212]/70 text-base md:text-lg max-w-2xl leading-relaxed">
              La visibilità dei contenuti è amplificata dall'ecosistema editoriale del gruppo —{" "}
              {ECOSYSTEM_SITES.map((s, i) => (
                <span key={s.url}>
                  <a href={s.url} target="_blank" rel="noreferrer noopener" className="text-[#121212] underline decoration-black/20 hover:decoration-[#FF6B1A] hover:text-[#FF6B1A] transition-colors">
                    {s.name}
                  </a>
                  {i < ECOSYSTEM_SITES.length - 1 ? ", " : ""}
                </span>
              ))}
              {" "}— attraverso una promozione integrata.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {ECOSYSTEM_CHANNELS.map((ch, i) => {
            const Icon = ICON_MAP[ch.key] || FileText;
            return (
              <motion.article
                key={ch.key}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.05 }}
                data-testid={`ecosystem-${ch.key}`}
                className="rounded-lg bg-[#f7f5f0] ring-1 ring-black/[0.06] p-6 md:p-7 hover:ring-[#FF6B1A]/40 transition-colors"
              >
                <div className="flex items-start justify-between mb-6">
                  <span className="w-10 h-10 grid place-items-center rounded-full bg-white ring-1 ring-black/[0.08]">
                    <Icon size={16} strokeWidth={1.5} className="text-[#FF6B1A]" />
                  </span>
                  <span className="font-mono text-[10px] tracking-[0.22em] text-[#121212]/35">0{i + 1}</span>
                </div>
                <h3 className="font-display text-xl md:text-2xl tighter text-[#121212] mb-2">{ch.label}</h3>
                <p className="text-[#121212]/55 text-sm leading-relaxed">{ch.note}</p>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
